import React from 'react';
// Modules
import {
  Box, Skeleton, Text, VStack,
} from '@chakra-ui/react';

const PromotionCardSkeleton: React.FC = () => (
  <Box borderColor="gray.200" borderRadius="md" borderWidth="1px" overflow="hidden">
    <Box borderBottomColor="gray.200" borderBottomWidth="1px" position="relative" pt="100%">
      <Skeleton bottom="0" left="0" position="absolute" right="0" top="0" />
    </Box>
    <VStack alignItems="flex-start" px="4" py="2" spacing="1">
      <Skeleton>
        <Text fontSize="lg" fontWeight="semibold">
          Nama Produk
        </Text>
      </Skeleton>
      <Skeleton>
        <Text>100 poin</Text>
      </Skeleton>
    </VStack>
  </Box>
);

export default PromotionCardSkeleton;
